// extracted by mini-css-extract-plugin
export default {"modal":"VideoModal_modal__gtIZ5","video":"VideoModal_video__TOeCR","closeBtn":"VideoModal_closeBtn__SA+Fu","svg":"VideoModal_svg__zkk8O"};